import { TypedAplication } from '../../@types';

export interface InsumoTalhao {
  descricao: string;
  id: string | number;
}

export interface UnidadeCompativel {
  id: number;
  descricao: string;
  abreviatura: string;
}

export interface MixedInsumos {
  id: string;
  nome: string;
  talhoes: InsumoTalhao[];
  unidadesCompativeis?: UnidadeCompativel[];
}

export interface Substituicao {
  insumoId: string;
  por: string | null;
  porDescricao: string | null;
  dose: string;
  unidade: string | null;
  talhoes: string[];
}

export type TabIndex = 0 | 1 | 2;

export interface AssistenteSubstituicaoInsumosProps {
  visible: boolean;
  onHide: () => void;
  itens: TypedAplication[];
}

export type ResultMap = Record<
  string | number,
  {
    id: string | number;
    nome: string;
    talhoes: { descricao: string; id: string | number }[];
    unidadesCompativeis: {
      id: number;
      descricao: string;
      abreviatura: string;
    }[];
  }
>;

export interface ProductOption {
  label: string;
  value: string;
  saldoFisico: number;
  saldoReceber: number;
  saldoEmUso: number;
  unidadeAbreviatura: string;
}

export const makeSubstituicao = (insumoId: string): Substituicao => ({
  insumoId,
  por: null,
  porDescricao: null,
  dose: '',
  unidade: null,
  talhoes: [],
});
